import styled from "styled-components";

const StyledNotificationsModal = styled.div<{ open?: boolean, }>`
  height: 100%;
  width: ${p => p.open ? "660px" : '0'};
  background: white;
  position: absolute;
  right: 0;
  display: flex;
  flex-direction: column;
  padding-top: 90px;
  padding-left: 50px;
  padding-right: 50px;
  overflow: auto;
  justify-content: space-between;

  .top {
    width: 100%;
    display: flex;
    flex-direction: column;

    .header {
      width: 100%;
      display: flex;

      .back {
        margin-right: 20px;
        font-size: 20px;
        display: flex;
        align-items: center;
        cursor: pointer;
      }

      .name {
        width: 100%;
        font-size: 26px;
        font-weight: bold;
      }

      .close {
        width: 20px;
        height: 20px;
      }
    }

    .content {
      margin-top: 70px;


      .content-info {
        margin-bottom: 40px;
        font-size: 20px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        b {
          margin-right: 5px;
        }

        .date {
          font-weight: normal;
        }
      }
    }
  }

  .bottom {
    width: 100%;

    .buttons {
      width: 100%;
      display: flex;
      justify-content: center;
      margin-bottom: 100px;
    }

  }

  @media (max-width: 1100px) {
    width: 100%;
    height: 100%;
    zoom: 0.85;
  }
`
export default StyledNotificationsModal